"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableOfContentsRedirectContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _CommentAnchorContext = require("./CommentAnchorContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function headingsReferencedBy(redirects) {
  var byHeadingParagraphId = new Map();
  var _iterator = _createForOfIteratorHelper(redirects),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var redirect = _step.value;
      var heading = byHeadingParagraphId.get(redirect.heading_paragraph_id);
      if (heading === undefined) {
        byHeadingParagraphId.set(redirect.heading_paragraph_id, {
          headingParagraphId: redirect.heading_paragraph_id,
          headingText: redirect.heading_text,
          entryCount: 1
        });
      } else {
        heading.entryCount += 1;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _toConsumableArray(byHeadingParagraphId.values());
}
function entriesPhraseOf(heading) {
  return heading.entryCount === 1 ? "the table of contents entry that references it." : "the ".concat(heading.entryCount, " table of contents entries that reference it.");
}
var TableOfContentsRedirectContext = exports.TableOfContentsRedirectContext = function TableOfContentsRedirectContext(_ref) {
  var redirects = _ref.redirects;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex flex-col gap-0.5",
    "data-sentry-component": "TableOfContentsRedirectContext",
    "data-sentry-source-file": "TableOfContentsRedirectContext.tsx",
    children: headingsReferencedBy(redirects).map(function (heading) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "text-[11px] leading-[16px] text-[#686766]",
        children: ["Changes text in ", heading.entryCount + 1, " places: the heading ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "text-[#4a5568] bg-[#FFF7E0] rounded px-0.5",
          children: "\"".concat((0, _CommentAnchorContext.snippetOf)(heading.headingText), "\"")
        }), " and ", entriesPhraseOf(heading)]
      }, heading.headingParagraphId);
    })
  });
};